"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.random = void 0;
var random = function () { return Math.random().toString(32).substring(2); };
exports.random = random;
